import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime, convertToNumericMonthAndDayAndYear } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import Modal from 'react-modal';
import LoadSpinner from "components/LoadSpinner";
import ReactJson from 'react-json-view';

const { DateTime } = require("luxon");

class DigiDipCommissionRawData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            show: false,
            rawData: null,
            rawDataLoading: false,
            commissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getCommissions();
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.startDate !== this.props.startDate || prevProps.endDate !== this.props.endDate) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        const { startDate, endDate } = this.props;
        let url = `/api/Merchant/GetDigiDipApiCommissionHistoryCreatedDatesAndIds`;

        let now = DateTime.now();
        let offset = now.offset;

        if (startDate) {
            url += `?startDate=${startDate.toSQL({ includeOffset: false })}`
        }

        if (endDate) {
            url += url.includes('?') ? `&endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}` : `?endDate=${endDate.plus({ days: 1 }).startOf('day').toSQL({ includeOffset: false })}`;
        }

        url += `&offset=${offset}`

        this.setState({ commissionsLoading: true });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commission raw data dates:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show });
    };

    hideModal = () => {
        this.setState({ show: false, rawData: null });
    }

    getCommissionRawData = async (id) => {
        let url = `/api/Merchant/GetDigiDipApiCommissionDataById?id=` + id;

        this.setState({ rawDataLoading: true });

        try {
            const commissionRawDataObject = await getRequest(url);
            const rawData = commissionRawDataObject.rawData
                ? JSON.parse(commissionRawDataObject.rawData)
                : null;

            this.setState({
                rawData,
                rawDataLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commission raw data by ID:", error);
            this.setState({ rawData: null, rawDataLoading: false });
        }
    };


    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "id",
                label: "ID",
                options: {
                    filter: true,
                    sort: true,
                    display: false,
                }
            },
            {
                name: "createdDate",
                label: "JSON Created Date",
                options: {
                    filter: true,
                    sort: true,

                    customBodyRender: (value, tableMeta) => {
                        const id = this.state.commissions[tableMeta.rowIndex]?.id;
                        const label = convertToNumericMonthAndDayAndYearAndTime(value, false).replace(',', '');

                        return (
                            <span
                                className="brandOrange"
                                style={{
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    textDecoration: 'underline'
                                }}
                                onClick={() => {
                                    this.setState({ show: true, rawData: null }, () => this.getCommissionRawData(id));
                                }}
                            >
                                {label}
                            </span>
                        );
                    }
                }
            },
            {
                name: "startDate",
                label: "Commissions Start Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value, tableMeta) => {
                        const label = convertToNumericMonthAndDayAndYear(value, false).replace(',', '');

                        return (
                            <span>{label}</span>
                        );
                    }
                }
            },
            {
                name: "endDate",
                label: "Commission End Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value, tableMeta) => {
                        const label = convertToNumericMonthAndDayAndYear(value, false).replace(',', '');

                        return (
                            <span>{label}</span>
                        );
                    }
                }
            },
        ];


        return (
            <div>
                <Modal
                    isOpen={this.state.show}
                    style={{
                        overlay: {
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 9998,
                        },
                        content: {
                            position: 'relative', // enables absolute positioning inside
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            border: '1px solid #ccc',
                            background: 'lightgray',
                            overflow: 'hidden', // prevent scrollbars on the whole modal
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '25px',
                            width: '85vw',
                            height: '85vh',
                            zIndex: 1060,
                        }
                    }}
                    onRequestClose={this.hideModal}
                >
                    {/* Close button */}
                    <button
                        onClick={this.hideModal}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '15px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        aria-label="Close modal"
                    >
                        &times;
                    </button>

                    {/* Scrollable content wrapper */}
                    <div style={{
                        height: '100%',
                        overflowY: 'auto',
                        paddingRight: '10px',
                        marginTop: '30px'
                    }}>
                        {this.state.rawDataLoading ? (
                            <LoadSpinner />
                        ) : this.state.rawData === null ? (
                            <div style={{ fontFamily: "sans-serif", fontSize: "18px" }}>No data available</div>
                        ) : (
                            <ReactJson
                                src={this.state.rawData}
                                name={false}
                                collapsed={2}
                                displayDataTypes={false}
                                enableClipboard={true}
                                style={{ fontSize: "14px" }}
                            />
                        )}
                    </div>
                </Modal>
                <ThemeProvider theme={this.state.commissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " available commission raw data rows by date" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.commissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default DigiDipCommissionRawData;
